export default __webpack_public_path__ + "static/media/logoName.701dab56.svg";